var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"sm":24}},[_c('div',{ref:"chart",staticStyle:{"height":"400px"},attrs:{"id":"bar-chart"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }